import Vue from 'vue'
import Vuex from 'vuex'

import theatreabove from './theatreabove'
import schedules from './schedules'
import news from './news'
import my from './my'
import seat from './seat'
import order from './order'
import home from './home'
import eventList from './eventList'
import huichang from './huichang'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    schedules,
    theatreabove,
    news,
    my,
    seat,
    order,
    home,
    huichang,
    eventList
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js